export const stringMapDefault = {
    ariaLabelCloseDialog: "Close Dialog"
};
